import { render, staticRenderFns } from "./tableRemit.vue?vue&type=template&id=654a6765&"
import script from "./tableRemit.vue?vue&type=script&lang=js&"
export * from "./tableRemit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports